import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const query_list_funds = graphql(`
  query query_list_funds {
    funds: feeders {
      id
      symbol
      token_address
      token_decimals
      # whitelist_address # TODO
      tradable

      fund_assets {
        nodes {
          asset {
            fission_ticker
            name
          }
          latest_published_nav {
            shares_value_held
          }
        }
      }

      starting_price_per_share
      target_range_lower_percentage
      target_range_upper_percentage

      earliest_published_nav {
        price_per_share
        published_at
      }
      one_year_published_nav {
        price_per_share
        published_at
      }
      latest_published_nav {
        cash_total_value
        price_per_share
        published_at
      }
    }
  }
`)

export const query_fund_navs = graphql(`
  query query_fund_navs($id: ID!) {
    fund_details: feeder_details(id: $id) {
      published_navs(last: 731) {
        nodes {
          date: published_at
          price_per_share
        }
      }
    }
  }
`)
